import { Theme } from "../Models/CustomSiteConfigModel";

class ThemeService {
  private theme: Theme | null = null;
  private listeners: Array<(theme: Theme | null) => void> = [];

  setTheme(newTheme: Theme) {
    this.theme = newTheme;
    this.listeners.forEach((callback) => callback(newTheme));
  }

  getTheme(): Theme | null {
    return this.theme;
  }

  subscribe(callback: (theme: Theme | null) => void): () => void {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((fn) => fn !== callback);
    };
  }
}

export const themeService = new ThemeService();
